var lx = lx || {};
lx.iframe = lx.iframe || {};
/*var lx.iframe.DialogClose = {
    dRefreshParent: function () {
        window.parent.location.reload();
    },
    dRefreshReport: function () {
        window.parent.lx.oldir.refresh();
    },
    dRefreshTaskList: function () {
        window.parent.lxTaskList();
    },
    qNewsRefreshPic: function () {
        window.parent.qNewsRefreshPic();
    }
};*/

lx.iframe.execClose = {
    dRefreshParent: function () {
        window.parent.location.reload();
    },
    dRefreshReport: function () {
        window.parent.lx.oldir.refresh();
    },
    dRefreshTaskList: function () {
        window.parent.lxTaskList();
    },
    qNewsRefreshPic: function () {
        window.parent.qNewsRefreshPic();
    }
};

lx.iframe.Height = function (pHeight, pFrameId) {
    var $dialog;
    if (pFrameId) $dialog = $("#" + pFrameId);
    else $dialog = $(".ui-dialog-content");
    $dialog.height(pHeight).css("max-height", "97vh");

    //$dialog = $(".ui-dialog");
    var dialogHeight = $dialog.height() + $(".ui-dialog-titlebar").height();
    console.log("dialogHeighttttt:"+dialogHeight);
    $(".ui-dialog").css("top", $(window).height() / 2 - dialogHeight / 2);
};

lx.iframe.FullHeight = function (pAdd, pFrameId) {
    var vAdd = pAdd;
    if (arguments.length == 0) vAdd = 20;
    var vH = $("body").height() + vAdd;
    parent.lx.iframe.Height(vH, pFrameId);
};

lx.iframe.DialogClose2 = function (pRefresh) {
    $(".ui-dialog-content").dialog("close");
    if (pRefresh == true) {
        window.location.reload();
    }
};

lx.iframe.dialog = function (pLink, pW, pH, pTitle, pJ) {
    var dialogWidth = pW;
    var dialogHeight = pH;

    // Determine size of the dialog
    var w = apex.jQuery(window);
    if (dialogWidth == 'max') {
        dialogWidth = w.width() - 40;
    } else {
        dialogWidth = (dialogWidth == 'auto' ? dialogWidth : parseInt(dialogWidth));
    }
    if (dialogHeight == 'max') {
        dialogHeight = w.height() - 80;
    } else {
        dialogHeight = (dialogHeight == 'auto' ? dialogHeight : parseInt(dialogHeight));
    }

    apex.navigation.dialog(pLink, {
        title: pTitle,
        height: dialogHeight,
        width: dialogWidth,
        modal: true,
        resizable: true,
        close: function (event, ui) { if (pJ) lx.iframe.execClose[pJ](); }
    },
        '',
        '');
};

var execDialogClose = lx.iframe.execClose;
var iFrameDialogClose = lx.iframe.DialogClose2;
var iFrameHeight = lx.iframe.Height;
var iFrameFullHeight = lx.iframe.FullHeight;
var iFrameDialog = lx.iframe.dialog;